module.exports = __webpack_public_path__ + "static/media/Schritt_4_Endlich_Feierabend.0f0d00b1.pdf";